import { FC, useEffect, useState } from 'react'
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate'
import { StockPersonalENTITY } from 'sigo-entities'
import { AdapterGenerico } from '../../../shared/Infraestructure/AdapterGenerico'
import { OffCanvasBottom } from '../../../shared/Components/ReactBootstrap/OffCanvasBottom/OffCanvasBottom'
import { Series } from './Series'

interface Props {
	item: StockPersonalENTITY
}

export const Card: FC<Props> = ({ item }) => {
	const [stock, setStock] = useState<number>(0)
	const [show, setShow] = useState<boolean>(false)
	const langTrans = LanguageTranslate()

	useEffect(() => {
		const disponible = item.Despacho - item.Devolucion - item.Liquidacion + item.DespachoTR - item.DevolucionTR
		const despachoTemporal = 0
		setStock(disponible - despachoTemporal)
	}, [item])

	const handleClickSerie = (item: StockPersonalENTITY) => {
		try {
			setShow(true)
		} catch (error) {
			console.error(error)
			AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
		}
	}

	return (
		<>
			<div className='d-flex flex-row card rounded-3 p-3 mb-1' style={{ backgroundColor: '#343e56' }}>
				<div className='col-2 d-flex align-items-center'>
					<div
						className='rounded-circle d-flex align-items-center justify-content-center'
						style={{
							width: 45,
							height: 45,
							backgroundColor: '#049bed'
						}}
					>
						<span className='text-white fw-bold fs-6'>
							{Number(stock.toFixed(2))}
						</span>
					</div>
				</div>
				<div className='col-10'>
					<div className='row'>
						<div className='col-4'>
							<h6 className='text-white'>{langTrans.general.Codigo}</h6>
						</div>
						<div className='col-8'>
							<h6 style={{ color: '#95a0b9' }}>{item.Item.Codigo}</h6>
						</div>
					</div>
					<div className='row'>
						<div className='col-4'>
							<h6 className='text-white'>{langTrans.general.Descripcion}</h6>
						</div>
						<div className='col-8'>
							<h6 style={{ color: '#95a0b9' }}>{item.Item.Descripcion}</h6>
						</div>
					</div>
					<div className='row'>
						<div className='col-4'>
							<h6 className='text-white'>{langTrans.general.Lote}</h6>
						</div>
						<div className='col-8'>
							<h6 style={{ color: '#95a0b9' }}>{item.Lote ? item.Lote : '-'}</h6>
						</div>
					</div>
					<div className='row'>
						<div className='col-4'>
							<h6 className='text-white'>{langTrans.general.Bobina}</h6>
						</div>
						<div className='col-8'>
							<h6 style={{ color: '#95a0b9' }}>{item.Bobina ? item.Bobina : '-'}</h6>
						</div>
					</div>
					{
						item.Item.Ind_SB === 'S' &&
						<div className='row'>
							<div className='col-4'>
								<h6 className='text-white'>{'Serie'}</h6>
							</div>
							<div className='col-8'>
								<h6
									style={{ color: '#ff2b2bff', fontWeight: 'bold' }}
									onClick={() => handleClickSerie(item)}
								>
									{item.Item.Ind_SB}
								</h6>
							</div>
						</div>
					}
				</div>
			</div>
			<OffCanvasBottom
				height={100}
				show={show}
				setShow={setShow}
				children={<Series item={item} />}
			/>
		</>
	)
}
